"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerContact = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var browser_1 = __importDefault(require("@emailjs/browser"));
var config_1 = require("config");
var Button_1 = __importDefault(require("../../components/Button"));
var Input_1 = __importDefault(require("../../components/Form/Input"));
var Textarea_1 = __importDefault(require("../../components/Form/Textarea"));
var Toast_1 = require("../../components/Toast");
var styles_1 = require("./styles");
function ContainerContact(_a) {
    var _b;
    var params = (0, react_router_dom_1.useSearchParams)()[0];
    var fullNameParams = (_b = params.get('n')) !== null && _b !== void 0 ? _b : '';
    var _c = (0, react_1.useState)(false), isSendingContactForm = _c[0], setIsSendingContactForm = _c[1];
    var _d = (0, react_1.useState)(fullNameParams), fullName = _d[0], setFullName = _d[1];
    var _e = (0, react_1.useState)(''), email = _e[0], setEmail = _e[1];
    var _f = (0, react_1.useState)('Consulta'), category = _f[0], setCategory = _f[1];
    var _g = (0, react_1.useState)(''), message = _g[0], setMessage = _g[1];
    var _h = (0, react_1.useState)(false), isAcceptForm = _h[0], setIsAcceptForm = _h[1];
    function clearForm() {
        setFullName('');
        setEmail('');
        setCategory('Consulta');
        setMessage('');
        setIsAcceptForm(false);
    }
    function handleSendFormSubmit(e) {
        return __awaiter(this, void 0, void 0, function () {
            var fullNameSanitize, emailSanitize, categorySanitize, messageSanitize, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setIsSendingContactForm(true);
                        fullNameSanitize = (0, sanitize_html_1.default)(fullName);
                        emailSanitize = (0, sanitize_html_1.default)(email);
                        categorySanitize = (0, sanitize_html_1.default)(category);
                        messageSanitize = (0, sanitize_html_1.default)(message);
                        if (fullNameSanitize.length === 0 ||
                            emailSanitize.length === 0 ||
                            messageSanitize.length === 0) {
                            Toast_1.toast.error('Todos los campos son requeridos y son todos textos');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, browser_1.default.send(config_1.emailjsServiceId, config_1.emailjsTemplateId, {
                                fullName: fullNameSanitize,
                                email: emailSanitize,
                                category: categorySanitize,
                                message: messageSanitize,
                            }, config_1.emailjsPublicKey)];
                    case 2:
                        _a.sent();
                        clearForm();
                        Toast_1.toast.success('Gracias por contactarnos, pronto nos estaremos comunicando con usted.');
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        Toast_1.toast.error('Ocurrió un error al enviar tu mensaje. Por favor, intentá nuevamente o escribinos por WhatsApp.');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsSendingContactForm(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, { children: (0, jsx_runtime_1.jsxs)(styles_1.Content, { children: [(0, jsx_runtime_1.jsx)(styles_1.ContentLeft, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Estamos ac\u00E1 para vos!" }), (0, jsx_runtime_1.jsx)("p", { children: "Si ten\u00E9s alguna duda o consulta dej\u00E1nos tus datos o escrib\u00EDnos por WhatsApp" })] }) }), (0, jsx_runtime_1.jsxs)(styles_1.ContentRight, __assign({ onSubmit: handleSendFormSubmit, style: {
                        pointerEvents: isSendingContactForm ? 'none' : 'auto',
                    } }, { children: [(0, jsx_runtime_1.jsx)(Input_1.default, { name: "name", label: "Nombres y Apellidos", placeholder: "Nombres y apellidos", defaultValue: fullName, value: fullName, onChange: function (e) { return setFullName(e.target.value); } }), (0, jsx_runtime_1.jsx)(Input_1.default, { name: "email", label: "Correo Electr\u00F3nico", placeholder: "Correo electr\u00F3nico", inputMode: "email", value: email, onChange: function (e) { return setEmail(e.target.value); } }), (0, jsx_runtime_1.jsxs)(styles_1.Label, { children: ["Categor\u00EDa", (0, jsx_runtime_1.jsxs)(styles_1.Select, __assign({ value: category, onChange: function (e) { return setCategory(e.target.value); } }, { children: [(0, jsx_runtime_1.jsx)("option", __assign({ value: "Consulta" }, { children: "Consulta" })), (0, jsx_runtime_1.jsx)("option", __assign({ value: "Otro" }, { children: "Otro" })), (0, jsx_runtime_1.jsx)("option", __assign({ value: "Contacto asesor comercial" }, { children: "Contacta un asesor comercial" }))] }))] }), (0, jsx_runtime_1.jsx)(Textarea_1.default, { value: message, onChange: function (e) { return setMessage(e.target.value); }, name: "message", label: "Mensaje" }), (0, jsx_runtime_1.jsxs)(styles_1.InputCheck, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", onChange: function (e) { return setIsAcceptForm(e.target.checked); }, checked: isAcceptForm }), ' ', (0, jsx_runtime_1.jsxs)("p", { children: ["Acepto el Tratamiento de mis Datos Personales. Para mayor informaci\u00F3n revis\u00E1 nuestra", ' ', (0, jsx_runtime_1.jsx)("a", __assign({ href: "".concat(window.location.origin, "/privacy-policy-and-protection-of-personal-data"), target: "_blank", rel: "noreferrer" }, { children: "Pol\u00EDtica de Privacidad y Protecci\u00F3n de Datos Personales" })), "."] })] }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "purple", type: "submit", fullWidth: true, disabled: !isAcceptForm || isSendingContactForm }, { children: isSendingContactForm ? 'Enviando...' : 'Enviar' }))] }))] }) }));
}
exports.ContainerContact = ContainerContact;
